export const types = {
    SET_GET_LANDINGS: '[LANDINGS] SET GET LANDINGS',
    SET_GET_LANDINGS_BY_ID: '[LANDINGS] SET GET LANDINGS BY ID'
}